var exports = {
  "a": "Box__s4Se8g",
  "o": "Token__SrdinH",
};

module.exports = exports;
